import React, { useEffect } from "react";
import DMSHeader from "../../DMSHeader/DMSHeader";
//import DailyFloodReportCompTable from "./DailyFloodReportCompTable";
import { useTranslation } from "react-i18next";
import DailyColdWaveReportForm from "./DailyColdWaveReportForm";
import "../ReportEnhanced.css";

const DailyColdWaveReport = () => {
  const { t } = useTranslation();

  return (
    <div className="report-enhanced-wrapper">
      <div className="report-header-enhanced">
        <DMSHeader title="Cold wave casualty and relief distribution daily report" />
      </div>
      <div className="report-table-enhanced">
        <DailyColdWaveReportForm />
      </div>
    </div>
  );
};

export default DailyColdWaveReport;
